import React from 'react';

const DriversPage: React.FC = () => {
  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="mb-8">
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">Drivers</h1>
        <p className="text-gray-600">Manage your fleet drivers</p>
      </div>

      <div className="bg-white rounded-lg border border-gray-200 p-8 text-center">
        <i className="ri-user-line text-4xl text-gray-300 mb-4 block"></i>
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          Driver Management
        </h3>
        <p className="text-gray-500">
          Driver management features coming soon...
        </p>
      </div>
    </div>
  );
};

export default DriversPage;
